<template>

    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('订单取消原因.名称')" prop="name" >
        <a-input v-model="name" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('订单取消原因.名称')" />
      </a-form-model-item>
      <a-col :md="6" :sm="24">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
        </a-space>
      </a-col>
    </a-form-model>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import {getTask, updateTask} from "@/api/order/cancelCause";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      name:'',
      errorMessage:undefined,
      labelCol: { span: 4 },
      wrapperCol: { span: 5 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',

      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {

        name: [
          { required: true, message: this.$t('订单取消原因.名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
    getTask().then(response => {
      this.name = response.data
    })
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },


    /** 提交按钮 */
    submitForm: function () {

      const taskName= this.name
      console.log(11111111,taskName)
      updateTask({"cron":taskName}).then(response => {

        this.$message.success(
          response.message,
          3
        )
      })
    }
  }
}
</script>
